import ButtonText from "@visa/vds/button-text";
import Icon from "@visa/vds/icon";
import ListboxItem from "@visa/vds/listbox-item";
import ListboxItemContainer from "@visa/vds/listbox-item-container";
import React from "react";
import "./ActionMenu.css";

const ActionMenuItem = (props) => {
  return (
    <ListboxItem role="none">
      <ListboxItemContainer>
        <ButtonText
          isFullWidth
          data-id={props.dataId}
          data-name={props.dataName}
          onClick={props.clickHandler}
        >
          <Icon name={props.iconName} resolution="low" />
          {props.buttonText}
        </ButtonText>
      </ListboxItemContainer>
    </ListboxItem>
  );
};

export default ActionMenuItem;
